import { css } from 'config/emotionCss';

export const cardStyle = css`
  position: relative;
  margin: 0 auto;
  top: 100px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  &.ant-card {
    width: 520px;

    > .ant-card-body {
      padding: 24px 0 0 0;

      > .content {
        padding: 0 24px;
      }

      > .ant-timeline {
        margin: 0 24px;

        .ant-timeline-item {
          &-last {
            padding-bottom: 0;
          }
        }
      }

      .ant-form-item {
        margin: 12px 0 0 0;
      }

      .ant-input-prefix {
        color: #b9bcbf;
      }
    }
  }
`;

export const resetPasswordCardStyle = css`
  &.ant-card {
    > .ant-card-body {
      padding: 0;
    }
  }
`;
